import React from 'react';
import { usePayment } from '../../../context/contextPayment';
import { useAuth } from '../../../context/contextAuth';
import LoadPlan from './loadPlan';
import LoadPayment from './loadPayment';
import LoadBtn from './loadBtn';
import ToggleSwitch from './toggleSwitch';
import TestBtn from './testBtn';

const Cards = () => {
  const {
    loadingPayment,
    getPaymentLink,
    plans,
    loadingPlans,
    loadingPlanId,
    setLoadingPlanId,
    isYearly,
    subId,
  } = usePayment();
  const { userId } = useAuth();

  console.log('plans from upgrade card', plans);
  if ((!Array.isArray(plans) || plans.length < 3) || loadingPlans) {
    return <LoadPlan />
  }
  if (loadingPayment) {
    return <LoadPayment />
  }

  const handleGetPaymentLink = async (plan_id, plan_cycle) => {
    if (loadingPlanId) return;
    setLoadingPlanId(plan_id);
    
    try {
      await getPaymentLink(userId, plan_id, plan_cycle);
    } catch (error) {
      console.error("Payment Link Generation Failed:", error);
    } finally {
      console.log("Process Completed");
      setLoadingPlanId(null);
    }
  };

  const DISCOUNTS = [
    { name: "Basic", off: 20 },
    { name: "Premium", off: 30 },
    { name: "Enterprise", off: 40 },
  ];

  const plans_data = DISCOUNTS.map((discount, index) => {
    const monthlyPlan = plans[index];
    const yearlyPlan = plans[index + 3];

    const yearlyPriceUndiscounted = (monthlyPlan?.amount || 0) * 12;
    const yearlyDiscountedTotal = yearlyPlan?.amount || 0;
    const discountedMonthlyRate = yearlyDiscountedTotal;

    return {
      id: monthlyPlan?.plan_id || yearlyPlan?.plan_id || `plan-${index}`,
      name: monthlyPlan?.name || yearlyPlan?.name || "Plan",
      off: discount.off,
      monthlyPlanId: monthlyPlan?.plan_id,
      monthlyPrice: monthlyPlan?.amount || 0,
      yearlyPlanId: yearlyPlan?.plan_id,
      yearlyDiscountedTotal,
      yearlyPriceUndiscounted,
      discountedMonthlyRate,
    };
  }).filter((plan) => plan.monthlyPlanId || plan.yearlyPlanId);

  const formatWithCommas = (number) => {
    return Math.round(number || 0).toLocaleString("en-IN");
  };

  return (
    <>
    {
      loadingPayment ? <LoadPayment /> : (
      <div className="upgrade-card">       
        <div className="d-flex flex-column justify-content-center align-items-center p-3">
          <div className="fs-1 fw-bold">
            Choose Your Perfect Plan
          </div>
          <div className="fs-6 fw-semibold mb-5 col-lg-6 col-12 text-center">
            Tailored Solutions for Every Business – Flexible Monthly and Yearly Options
          </div>
          <ToggleSwitch />        
          <div className="col-12">
            <div
              className="d-flex flex-lg-row flex-column 
                justify-content-center align-items-stretch 
                gap-lg-4 gap-1 mx-auto"
            >
              {plans_data.map((plan) => (
                <div key={plan.id} className="px-lg-0 px-4 py-lg-0 py-3 d-flex">
                  <div
                    className="subs-card text-center p-4 rounded-4 shadow-sm bg-white 
                    position-relative w-100 d-flex flex-column justify-content-between"
                    style={plan.name === "Premium" ? { borderColor: "#007bff" } : {}}
                  >
                    {plan.name === "Premium" && (
                      <div className="badge-popular">Most Popular</div>
                    )}

                    <div>
                      <h3 className="plan-name mb-3 fs-2 fw-bold">{plan.name}</h3>
                      {plan.name === "Enterprise" ? (
                        <div className="fs-5 fw-semibold text-muted mb-4">
                          Custom Pricing
                        </div>
                      ) : (
                        <>
                          <div className="d-flex justify-content-center align-items-center">
                            <span className="fs-3 pe-1">₹</span>
                            <span
                              key={isYearly}
                              className="fs-lg-1 fs-2 fw-bold price discounted-price"
                            >
                              {isYearly
                                ? formatWithCommas(plan.yearlyDiscountedTotal * 12)
                                : formatWithCommas(plan.monthlyPrice)}
                            </span>
                          </div>

                          <div className="fs-6 mb-3">
                            {isYearly ? "per year (Billed Annually)" : "per month"}
                          </div>
                          {isYearly && (
                            <div className="discount-section my-2">
                              <span className="discount-percent badge bg-success text-white">
                                SAVE {plan.off}%
                              </span>

                              <div className="text-muted fs-6 mt-2">
                                (₹{formatWithCommas(plan.discountedMonthlyRate)} / Month)
                              </div>

                              <div className="text-muted text-decoration-line-through fs-7">
                                Was ₹{formatWithCommas(plan.yearlyPriceUndiscounted)}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className="btn-area mb-1 mt-3">
                      {plan.name === "Enterprise" ? (
                        <a href="tel:+918274945139" className="btn btn-dark rounded-3 px-4 py-2 w-100 fw-semibold">
                          Contact Sales  
                        </a>
                      ) : (
                        <>
                          {/* <button
                            className="btn btn-primary rounded-3 px-4 py-2 w-100 fw-semibold"
                            onClick={() =>
                              handleGetPaymentLink(
                                isYearly ? plan.yearlyPlanId : plan.monthlyPlanId, 1
                              )
                            }
                            disabled={loadingPlanId}
                          >
                            {loadingPlanId ===
                            (isYearly ? plan.yearlyPlanId : plan.monthlyPlanId) ? (
                              <LoadBtn />
                            ) : (
                              "Get Started"
                            )}
                          </button> */}
                          <TestBtn />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default Cards;
